import styled, { css } from 'styled-components';
import { TypographyStyles, colours, focusOutline, media, spacing } from '../../../stylings';

export const Button = styled.a<{ $isDisabled?: boolean; $noMaxWidth?: boolean }>`
  ${TypographyStyles.Button.MontserratSemiBold}
  align-items: center;
  background-color: ${({ $isDisabled }) => ($isDisabled ? colours.LIGHT_GREY_2 : colours.TURQUOISE)};
  border: ${({ $isDisabled }) => ($isDisabled ? `1px solid ${colours.MID_GREY}` : 0)};
  color: ${({ $isDisabled }) => ($isDisabled ? colours.GREY : colours.BLACK)};
  display: flex;
  gap: ${spacing.XXS};
  height: 100%;
  justify-content: center;
  min-height: 48px;
  pointer-events: ${({ $isDisabled }) => ($isDisabled ? 'none' : 'auto')};
  text-decoration: none;
  text-transform: initial;
  width: 100%;

  ${({ $noMaxWidth }) =>
    $noMaxWidth
      ? null
      : css`
          max-width: 328px;
        `}

  &:hover,&:focus {
    opacity: 0.9;
  }

  &:focus-visible {
    ${focusOutline}
  }
`;

export const ButtonContainer = styled.div<{ $isDisabled?: boolean; $noMaxWidth?: boolean }>`
  cursor: ${({ $isDisabled }) => ($isDisabled ? 'not-allowed' : 'pointer')};
  width: 100%;

  ${({ $noMaxWidth }) =>
    $noMaxWidth
      ? null
      : css`
          max-width: 328px;
        `}

  @media ${media.greaterThan('lg')} {
    margin-top: ${spacing.XS};
  }
`;
